module.exports = __webpack_public_path__ + "mini reggie.gif?49c84ba806bcde6dc0d647fedb2977e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mini reggie.gif
// module id = 137
// module chunks = 0